import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {UserFilters} from '../../../../data/models/filters/user-filters';
import {FormBuilder, FormGroup} from '@angular/forms';

@Component({
  selector: 'app-user-filters',
  templateUrl: './user-filters.component.html',
  styleUrls: ['./user-filters.component.css']
})
export class UserFiltersComponent implements OnInit, OnChanges {

  @Input() filters: UserFilters = {};

  @Output() apply = new EventEmitter<UserFilters>();

  public form!: FormGroup;

  constructor(
    private fb: FormBuilder,
  ) {
    this.form = this.fb.group({
      search: [''],
    });
  }

  ngOnInit(): void {
    this.form.controls.search.setValue(this.filters.search);
  }

  ngOnChanges(changes: SimpleChanges): void {
    const filters = changes.filters.currentValue;
    this.form.controls.search.setValue(filters.search);
  }

  onSubmit(event: MouseEvent): void {
    event.preventDefault();
    const search = this.form.controls.search.value || null;
    this.apply.emit({search});
  }

  onClear(event: MouseEvent): void {
    event.preventDefault();
    this.form.controls.search.setValue('');
    this.apply.emit({});
  }

}
